import { Nullable } from "../base-types";
import CultureInfo from "../culture-info";
import Guard from "../guard";

export class CultureCache {
    private _map: Map<string, Array<CultureInfo>> = new Map();
    private _cacheKey = "cultures";

    loadCache(cultures: Array<CultureInfo>): void {
        Guard.notNullOrUndefined(cultures);

        this._map.set(this._cacheKey, cultures);
    }

    getCachedCultures(): Nullable<Array<CultureInfo>> {
        return this._map.get(this._cacheKey) || null;
    }
}
